import AxiosInstance from '../../../http-config'
import { AppConfigurationKey } from '../../../../model/enums/appConfigurationKey'
import { getAppConfigurationValue } from '../../../../redux/helpers'

import { PriceVersionModel } from './model/priceVersion.model'
import { BatchVersionSingleRequest } from './model/batchVersionSingleRequest.model'
import { EditablePriceVersionModel } from './model/EditablePriceVersion.model'

export const fetchVersionsByPriceId = async (priceId: number): Promise<PriceVersionModel[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(`${apiSuffixUrl}/api/Versions/Price/${priceId}`).then(response => {
    return response.data
  })
}

export const fetchVersionByID = async (id: number): Promise<PriceVersionModel> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  return await AxiosInstance.get(`${apiSuffixUrl}/api/Versions/${id}`).then(response => {
    return response.data
  })
}

export const apiDeleteVersion = async (versionId: number): Promise<any> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.delete(`${apiSuffixUrl}/api/Versions/${versionId}`).then(response => {
    return response.data
  })
}

export const apiPostVersion = async (request: PriceVersionModel): Promise<any> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.post(`${apiSuffixUrl}/api/Versions`, request).then(response => {
    return response.data
  })
}

export const apiPatchPriceVersion = async (
  priceId: number,
  priceVersion: EditablePriceVersionModel
): Promise<any> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  const request = {
    priceId,
    priceVersion
  }

  return await AxiosInstance.post(
    `${apiSuffixUrl}/api/Versions/PatchPriceVersionForPrice`,
    request
  ).then(response => {
    return response.data
  })
}

export const apiHandleBatchVersions = async (
  requests: BatchVersionSingleRequest[]
): Promise<any> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  function toString(o) {
    Object.keys(o).forEach(k => {
      if (typeof o[k] === 'object' && o[k] !== null && o[k] !== undefined) {
        return toString(o[k])
      }
      if (o[k] === null || o[k] === undefined) {
        return o[k]
      } else {
        o[k] = '' + o[k]
      }
    })

    return o
  }

  const batchRequest = requests.map((singleRequest, idx) => {
    if (singleRequest.method === 'POST') {
      singleRequest.body?.id && delete singleRequest.body?.id
      return {
        id: singleRequest.id,
        method: singleRequest.method,
        atomicityGroup: singleRequest.atomicityGroup,
        url: `/odata/versions`,
        body: toString(singleRequest.body)
      }
    } else if (singleRequest.method === 'PATCH') {
      const versionId = singleRequest.body?.id
      singleRequest.body?.id && delete singleRequest.body?.id
      return {
        id: singleRequest.id,
        method: singleRequest.method,
        atomicityGroup: singleRequest.atomicityGroup,
        url: `/odata/versions(${versionId})`,
        body: toString(singleRequest.body)
      }
    } else if (singleRequest.method === 'DELETE') {
      return {
        id: singleRequest.id,
        method: singleRequest.method,
        atomicityGroup: singleRequest.atomicityGroup,
        url: `/odata/versions(${singleRequest.body?.id})`
      }
    } else return singleRequest
  })

  const request = { requests: batchRequest }

  return await AxiosInstance.post(`${apiSuffixUrl}/api/Versions/handleBatchVersions`, request).then(
    response => {
      return response.data
    }
  )
}
